<template>
  <div>
    <img
        :src="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAkCAYAAAD7PHgWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANhSURBVHgBzZhPTttAFMbfG6f/0i6yLJSFCd1UlEq9QbhBewLgBNATJDlB4ASEE5QbwA2KCKiLgnCl0naHK7WoLfFM37M9yRBsx2MblU+yMs5M7C/feH5+NkCFOmo+6w2asx2oUAgV6aP71A0cccZtJ5DzL7zvHlQgARXpysGObgeOsw0VqZIEB+5cCx25x20F4NNBGwrF8tLJl30oqUoSFEKGiSmELjnc4jYq1YYKVNrg8cKzVTLmUmpebSj7Q3l/k1Mkuy3ug5Iqn+AoKezywnjteT4iduPO9pnbaEAJlTJ43Jxt6/QWT8/7+vuXJ+ebqMCjJN2for4BJVTYIGOFPlajPZ3YWFKItbAHYb1MioUNMlbi9HbN9LSiFYy0QeOXeFR4wRQyyOkJwJXwAIF8lzZO6WsRcSNO3FqFDBpQ7mfdMThFCWqH20XhbW3w0J15o9OjW1p32vggeLChsTN4PtcCS9XAUo7AHp0whLKZ3iTz9HXJ2KECYovuWe0Y3vtgIasETSg/GV5umn00lWRcbcdbz+wrA+/cBkNUGFCe93z/2oEUjPaZgWafCW82b4Od3AYvRX09CcpatGI9o+1P9jO8qeOAmg0beOcyyIggcx1uB6ASsSKl/DzeUz+SxiiB4W9t4J3LoImVV6ffdpPGIApjisdpmroGb6fegyoMmlDOwgpPvW4rkF7qOAF6BlbzYGeqQQOwmVCmaRslKBBSxy1+Oj9QgLlrxkyDERJUi9OZBmUZjKc1QMfPGjsM7nXywjs7wfgfSoSdaQ9BNRiO+sXwT6ZBxo6uvIWS24UMmlBeOvnagSn6DQ995h9vdbjypo1neOua8ag5k4qdxIcmXhhUz+1FBnEtiXtVKAyB7jzU9B8Hl/OT8GclJkjmVrKgnCZmm81dIjp2hJ00eN8waEJZYlQV5xGX/8S2C96ypmxSumZkeCfVjDcMmlC2ea7Vfwqis+WuoE1405uJdqbBvFBONAhGsWC088gJAj1TN+B9zWAgnPdxs2/7boUu9jUuBmhlHhCp39r8ls+VBu/RKtYrihcGPWcsV/XyJ68+uG6j5vw9m3xtMk7QAsq3oTR4hwZtoXxbMuGt3zOKcGkblTL8R4UpGthhpuLhwkxfr9y7JqWgi4OF2Qu+MOEOii+5f5s3u2VIJhn1AAAAAElFTkSuQmCC'"
        class="warning__step__icon">

    <h1
        class="
        warning__step__title">
      {{ title }}
    </h1>

    <p class="warning__step__description">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: "WarningStep",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      icons: {
        warning: require("@/assets/icons/new-ui/customer/authorizations/shared/warning.svg"),
      },
    };
  },
};
</script>

<style scoped>
.warning__step__icon {
  width: 40px;
  height: 36px;
}

.warning__step__title {
  margin-top: 14px;
  margin-bottom: 8px;
  width: 570px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #424242;
}

.warning__step__description {
  margin-top: 8px;
  width: 570px;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #424242;
}
</style>
